import styled from 'styled-components'
import { Tags } from 'components/tags/s'
import { ChipLink } from 'components/link'
import { flexChildShrinkCss } from 'components/flex'

export const Wrapper = styled.div`
    &:not(.compact) {
        margin-bottom: 24px;
    }
`

export const Links = styled(Tags)`
    flex-wrap: wrap;
    align-items: center;

    width: 100%;
    min-height: 40px;
`

export const Chip = styled(ChipLink)`
    ${flexChildShrinkCss}

    margin: 0 8px 8px 0;
`